import { FC } from 'react';
import FullWidthVideo from 'components/commercetools-ui/organisms/content/cms-components/full-width-video';
import ImageBanner from 'components/commercetools-ui/organisms/content/cms-components/image-banner';

export type CmsMaterContainerProps = {
  data?: any;
};
const CmsMaterContainer: FC<CmsMaterContainerProps> = ({ data }) => {

  const renderContentStackComponents = () => {
    const componentList = [];
    const { sections = [] } = data;
    for (let i = 0; i < sections.length; i++) {
        const componentObj = sections[i];
        const compType = Object.keys(componentObj)?.[0];
        const dataToPass = componentObj[compType];

        switch (compType) {
          case "section_with_image_text":
            componentList.push(<ImageBanner content={dataToPass} />);
            break;

          case "section_with_video":
            componentList.push(<FullWidthVideo content={dataToPass} />);
            break;
        }
    }
    return componentList;
  }
  return (
    <>
        {renderContentStackComponents()}
    </>
  );
};
export default CmsMaterContainer;
